import { atom } from 'jotai';

import { instanaReportError } from '@bizzabo/instana-api';

import { joinChannelApi } from '../notifications/api/http';
import { createVideoMeetings, DUPLICATE_STATUS_ERROR_MESSAGE } from './api';

export enum RejectionType {
    Decline,
    Timeout,
    InAnotherCAll,
}

type Update = {
    callerUserProfileId: number;
    eventId: number;
    members: number[];
    source: {
        type: string;
        channelId: string;
    };
};

type DeclineModal =
    | {
          isOpen: false;
      }
    | {
          isOpen: true;
          rejectionType: RejectionType;
          guestProfileId: number;
      };

type EndModal =
    | {
          isOpen: false;
      }
    | {
          isOpen: true;
      };

const initialVideoValue = {
    callerUserProfileId: null,
    guestProfileId: null,
    meetingId: '',
    agora: {
        agoraChannelId: '',
        uid: '',
        token: '',
        streamId: '',
    },
};

export const declineModalAtom = atom<DeclineModal>({ isOpen: false });
export const endModalAtom = atom<EndModal>({ isOpen: false });
export const showVideoAtom = atom(false);
export const videoAtom = atom(initialVideoValue);

export const createVideoAtom = atom(null, async (_, set, update: Update) => {
    try {
        const { id, meetingChannel } = await createVideoMeetings(
            update.eventId,
            update.members,
            update.source
        );
        set(videoAtom, {
            callerUserProfileId: update.callerUserProfileId,
            guestProfileId: update.members[0],
            meetingId: id,
            agora: {
                agoraChannelId: meetingChannel.channelId,
                uid: meetingChannel.uid,
                token: meetingChannel.token,
                streamId: meetingChannel.streamId,
            },
        });
        set(showVideoAtom, true);
    } catch (error) {
        if (error.message === DUPLICATE_STATUS_ERROR_MESSAGE) {
            set(showVideoAtom, true);
            set(declineModalAtom, {
                isOpen: true,
                rejectionType: RejectionType.InAnotherCAll,
                guestProfileId: update.members[0],
            });
        } else {
            throw Error(error);
        }
    }
});

export const closeVideoAtom = atom(null, (_get, set) => {
    set(showVideoAtom, false);
    set(declineModalAtom, { isOpen: false });
    set(endModalAtom, { isOpen: false });
    set(videoAtom, initialVideoValue);
});

type JoinVideoParams = {
    eventId: number;
    meetingId: string;
    hostProfileId: number;
    guestProfileId: number;
};

export const joinVideoAtom = atom<null, JoinVideoParams>(null, async (_get, set, update) => {
    set(showVideoAtom, true);

    try {
        const { id, meetingChannel } = await joinChannelApi(update.eventId, update.meetingId);

        set(videoAtom, {
            callerUserProfileId: update.hostProfileId,
            guestProfileId: update.guestProfileId,
            meetingId: id,
            agora: {
                agoraChannelId: meetingChannel.channelId,
                uid: meetingChannel.uid,
                token: meetingChannel.token,
                streamId: meetingChannel.streamId,
            },
        });
    } catch (error) {
        instanaReportError({ error });
    }
});
